// 분석 및 보고서 — 서버 응답을 화면 값으로 바꾸는 순수 함수들. 날짜는 모두 서울 기준이다.
const TZ = "Asia/Seoul";

export const seoulDate = (v) => new Date(v).toLocaleDateString("sv-SE", { timeZone: TZ });

// 서버의 "서울 날짜, 오늘 포함 N일"과 같은 날짜 열쇠(오래된 것부터)
export function dayKeys(days, now = new Date()) {
    const keys = [];
    for (let i = days - 1; i >= 0; i -= 1) keys.push(seoulDate(now.getTime() - i * 864e5));
    return keys;
}

export const dayLabel = (key) => {
    const [, m, d] = key.split("-").map(Number);
    return `${m}월 ${d}일`;
};

export const hourLabels = Array.from({ length: 24 }, (_, i) => `${i}:00`);

// 요약 daily_conversations([{date,count}], 서울 날짜마다 한 칸) → 기간 날짜 순 값. 빠진 날은 0
export function dailyCounts(points, keys) {
    const by = Object.fromEntries((points || []).map((p) => [p.date, Number(p.count) || 0]));
    return keys.map((k) => by[k] || 0);
}

// /api-cost/totals?group=day_product (날짜·제품별 줄) → 날짜별 계열과 제품별 합계
export function costSeries(rows, keys) {
    const idx = Object.fromEntries(keys.map((k, i) => [k, i]));
    const z = () => keys.map(() => 0);
    const s = { llmTok: z(), llmCost: z(), stt: z(), cost: z(), totals: { llmTok: 0, llmCost: 0, embTok: 0, embCost: 0, sttSec: 0, sttCost: 0, cost: 0 } };
    (rows || []).forEach((r) => {
        const i = idx[r.date];
        if (i === undefined) return;
        const c = Number(r.cost_usd) || 0;
        s.cost[i] += c;
        s.totals.cost += c;
        if (r.product === "llm") {
            s.llmTok[i] += Number(r.llm_tokens) || 0;
            s.llmCost[i] += c;
            s.totals.llmTok += Number(r.llm_tokens) || 0;
            s.totals.llmCost += c;
        } else if (r.product === "embedding") {
            s.totals.embTok += Number(r.embedding_tokens) || 0;
            s.totals.embCost += c;
        } else if (r.product === "stt") {
            s.stt[i] += c;
            s.totals.sttSec += Number(r.audio_seconds) || 0;
            s.totals.sttCost += c;
        }
    });
    return s;
}

export const DASH = "–";
export const minutes = (sec) => `${(Number(sec || 0) / 60).toFixed(1)}분`;
export const nf = (v) => Number(v || 0).toLocaleString("ko-KR");
export const usd = (v) => {
    const n = Number(v) || 0;
    return "$" + (n > 0 && n < 0.01 ? +n.toFixed(4) : n.toFixed(2));
};
export const pct = (r) => (r === null || r === undefined ? DASH : `${Math.round(r * 100)}%`);
export const num = (v, dec) => (v === null || v === undefined ? DASH : Number(v).toFixed(dec));
export function fileSize(b) {
    if (b === null || b === undefined) return DASH;
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / 1024 / 1024).toFixed(1)} MB`;
}
export const periodText = (days) => (days === 1 ? "오늘" : `최근 ${days}일`);
